import { ApiError } from "../lib/api";

export const apiErrorToMessage = (error: unknown, defaultMessage: string): string => {
  if (error instanceof ApiError) {
    if (typeof error.payload === "string" && error.payload.trim().startsWith("{")) {
      try {
        const parsed = JSON.parse(error.payload) as Record<string, unknown>;
        const candidate = parsed.message ?? parsed.detail ?? parsed.error;
        if (typeof candidate === "string" && candidate.trim().length > 0) {
          return candidate;
        }
      } catch {
        // Fall through to existing payload handling.
      }
    }

    if (
      error.payload !== null &&
      typeof error.payload === "object" &&
      !Array.isArray(error.payload)
    ) {
      const payload = error.payload as Record<string, unknown>;
      const candidate = payload.message ?? payload.detail ?? payload.error;
      if (typeof candidate === "string" && candidate.trim().length > 0) {
        return candidate;
      }
    }

    if (typeof error.payload === "string" && error.payload.trim().length > 0) {
      return error.payload;
    }

    const baseMessage = defaultMessage.replace(/\.$/, "");
    return `${baseMessage} (${error.status}).`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return defaultMessage;
};
